import React from 'react';
import { useLocation } from 'react-router-dom';
import styles from './PageHeader.module.css';

function PageHeader() {
  const location = useLocation();
  const pathname = location.pathname;

  const pageHeadings = {
    '/': 'Sapienta Venture Capital',
    '/portfolio': 'Portfolio',
    '/investment-criteria': 'Investment Criteria and Insights',
    '/company-information': 'Company Information and Insights',
    '/pressroom': 'Pressroom',
    '/investment-philosophy': 'Investment Philosophy',
    '/careers': 'Career Opportunities',
    '/terms-conditions': 'Terms & Conditions',
    '/privacy-policy': 'Privacy Policy',
    '/disclaimer': 'Disclaimer',
    '/cookie-policy': 'Cookie Policy'
  };

  const heading = pageHeadings[pathname];

  if (!heading) return null;

  return (
    <section className={styles.pageHeader}>
      <div className={styles.container}>
        <h1 className={styles.heading}>{heading}</h1>
      </div>
    </section>
  );
}

export default PageHeader;